// 全局的路由
global.antRouter = ''



// WEBPACK FOOTER //
// ./src/libs/global.js